var _style, _g, _path, _path2, _linearGradient, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnet_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 295 256.6",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".magnet_svg__st2{fill:none}.magnet_svg__st3{fill:#c2d0e1}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnet_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,62.7c0.3-15.3,9-29.8,23.8-39.6c15.1-9.2,37.7-11.3,53.8-3.2c4.9,2.5,9.1,5.7,13.9,8.1 c15.4,7.7,35.6,6.1,52.8,1.7s33.9-11.3,51.9-13.6s39,1.1,48.9,13.3s4.4,30-9.7,39.5c-12,8-29.7,11.7-36.3,23 c-2.4,4.9-3.5,10.3-3.3,15.8c-0.4,15.2-0.4,31.7,10.9,43.9c5.8,5.5,12.2,10.4,19,14.6c14.8,10.4,27.1,24.2,27.7,40.6 c0.2,5.3-1.2,10.6-3.9,15.2c-10.3,17.9-34,20.1-55.3,18.8c-16.2-0.9-32.8-3.5-48.4,0c-11.4,2.4-21.5,7.6-32.4,11.2 c-16.6,5.2-34.2,6.4-51.4,3.5c-10.2-1.3-19.8-5.1-28.2-11.1c-15.9-12.6-15.6-32.6-11.9-50s10.2-35.5,3.2-52.2 c-1.8-4.1-4.1-8-6.8-11.6C16.8,110.6,10.2,87.8,12.7,65L13.2,62.7z",
    fill: "#aaa",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st2",
    d: "M17.1 167.8L15.9 174.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M16.7,175.8c0.6-0.2,1.1-0.6,1.2-1.2L19,168c0.1-0.9-0.7-1.7-1.8-1.8c-0.9-0.1-1.9,0.4-2.2,1.3l-1.1,6.5 c-0.2,0.9,0.6,1.7,1.7,1.8C16,176,16.4,175.9,16.7,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st2",
    d: "M12.4 170.6L20.6 171.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M21.4 172.9c.8-.2 1.3-.9 1.2-1.7 0-.1-.1-.2-.1-.3-.3-.6-.9-1-1.6-1l-8.3-1c-1-.1-1.9.5-2.2 1.4 0 .9.7 1.7 1.7 1.7l8.3.9C20.7 173 21.1 173 21.4 172.9zM.5 136.1c-1.2-2.2.1-4.8 2.9-5.8s6.1.1 7.3 2.3-.1 4.8-2.9 5.8S1.7 138.3.5 136.1zM3.2 135.2c.7 1.1 2.1 1.5 3.3 1 1-.2 1.6-1.2 1.4-2.2 0-.2-.1-.3-.2-.4-.7-1-2.1-1.4-3.2-1-1 .2-1.6 1.2-1.4 2.2C3.1 134.9 3.2 135.1 3.2 135.2L3.2 135.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "magnet_svg__st3",
    cx: 13.3,
    cy: 194.3,
    rx: 3,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M175.6,246.7c0.8-0.9,2.1-1.2,3.1-0.7c0.3,0.1,0.6,0.4,0.8,0.7l1.3,1.7l1.3,1.7c0.5,0.7,0.3,1.7-0.4,2.3 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.4,0.2-0.7,0.2-1.1,0.2h-5.1c-1.1,0.1-2.1-0.7-2.3-1.8c0-0.3,0.1-0.6,0.3-0.9l1.3-1.7L175.6,246.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st2",
    d: "M280.9 115.2L276.5 120.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M276.5,122.5c0.7,0,1.3-0.3,1.7-0.8l4.4-5.6c0.4-0.7,0.1-1.6-0.6-2c-0.1-0.1-0.2-0.1-0.4-0.1 c-0.9-0.3-1.8-0.2-2.5,0.5l-4.4,5.6c-0.5,0.6-0.4,1.5,0.3,2c0.1,0.1,0.3,0.2,0.4,0.2C275.8,122.4,276.2,122.5,276.5,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st2",
    d: "M275.1 116.4L282.2 119.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M282.2 121.4c1 .1 1.9-.6 2-1.6 0-.6-.4-1.1-1-1.3l-7.1-3.5c-.9-.5-2.1-.4-2.8.3-.5.5-.5 1.4 0 2 .1.1.2.2.4.3l.3.2 7.1 3.5C281.5 121.3 281.9 121.4 282.2 121.4zM269.4 87.4c0-2.4 2.5-4.4 5.5-4.4s5.5 2 5.5 4.4-2.5 4.4-5.5 4.4l0 0C271.9 91.8 269.5 89.8 269.4 87.4zM272.4 87.4c-.3 1.4.6 2.8 1.9 3.1s2.8-.6 3.1-1.9c.3-1.4-.6-2.8-1.9-3.1-.2 0-.4-.1-.6-.1l0 0C273.7 85.3 272.6 86.2 272.4 87.4L272.4 87.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "magnet_svg__st3",
    cx: 280,
    cy: 150.6,
    rx: 3,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M291.9,172.3c-0.8-0.9-2.1-1.2-3.1-0.7c-0.3,0.1-0.6,0.4-0.8,0.7l-1.3,1.7l-1.3,1.7c-0.5,0.7-0.3,1.8,0.4,2.3 c0.1,0.1,0.3,0.2,0.4,0.2c0.4,0.2,0.8,0.2,1.1,0.2h5.1c1.1,0.2,2.2-0.5,2.5-1.6c0-0.4-0.1-0.8-0.3-1.1l-1.3-1.7L291.9,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st2",
    d: "M123.6 12.6L130.8 9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M65.7,11.1c0,2.4-2.5,4.4-5.5,4.4s-5.6-2-5.6-4.4s2.5-4.4,5.6-4.4S65.7,8.7,65.7,11.1z M57.6,11.1 c0.4,1.4,1.8,2.2,3.1,1.9c0.9-0.2,1.6-0.9,1.9-1.9c-0.2-1.2-1.3-2.1-2.5-2l0,0C58.9,9,57.8,9.9,57.6,11.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "magnet_svg__st3",
    cx: 192.6,
    cy: 11.9,
    rx: 3,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "magnet_svg__st3",
    d: "M240.4,5.4c-0.9-0.3-1.3-1.2-1.1-2c0.1-0.2,0.1-0.3,0.2-0.4c0.2-0.3,0.5-0.5,0.8-0.6l2.2-1l2.2-1 c1.1-0.5,2.3-0.2,3.1,0.7c0.2,0.3,0.3,0.6,0.3,0.9v3.9c-0.2,1.1-1.2,1.9-2.3,1.8c-0.4,0-0.8-0.1-1.1-0.2l-2.2-1L240.4,5.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-67.02 103.854 76.942)",
    fill: "#b3c8c9",
    d: "M90.8 55.8H116.8V98H90.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-67.02 199.83 117.646)",
    fill: "#afc5c6",
    d: "M186.8 96.5H212.8V138.7H186.8z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "magnet_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.388,
    y1: 154.145,
    x2: 214.189,
    y2: 154.145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27b40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec697d"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.3,121.4l-19.1,45.1c-6.7,15.7-24.9,23.1-40.6,16.4S92.4,158,99.1,142.3l19.1-45.1L79.3,80.7l-19.1,45.1 c-15.8,37.2,1.7,80.3,38.8,96s80.3-1.7,96-38.8l19.1-45.1L175.3,121.4z",
    fill: "url(#magnet_svg__SVGID_1_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.2,109.6l-38.9-16.5c-2.4-1-5.1,0.1-6.2,2.5c-3.1,7.4-26,61.3-29.3,69.1c-5.7,13.4-21.1,19.6-34.5,13.9 c-13.4-5.7-19.6-21.1-13.9-34.5c3.3-7.7,26.2-61.7,29.3-69.1c1-2.4-0.1-5.1-2.5-6.2L91.3,52.4c-2.4-1-5.1,0.1-6.2,2.5 c-3.1,7.4-26,61.3-29.3,69.1c-16.8,39.6,1.8,85.4,41.3,102.2s85.4-1.8,102.2-41.3c3.3-7.7,26.2-61.7,29.3-69.1 C229.7,113.3,228.6,110.6,226.2,109.6z M188,103.6l30.2,12.8l-6.5,15.3l-30.2-12.8L188,103.6z M92,62.9l30.2,12.8L115.7,91 L85.5,78.2L92,62.9z M190.7,181.1c-14.8,34.8-55.1,51.1-89.9,36.3c-34.8-14.8-51.1-55.1-36.3-89.9l17.3-40.8l30.2,12.8l-17.3,40.8 c-7.7,18.1,0.8,39.1,18.9,46.8c18.1,7.7,39.1-0.8,46.8-18.9l17.3-40.8l30.2,12.8L190.7,181.1L190.7,181.1z",
    fill: "#22313f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.6,11l-19,35.6c-1.2,2.2-3.9,3-6,1.9s-3-3.8-1.8-6l0,0l19.1-35.6c1.2-2.2,3.9-3,6-1.9 C150,6.2,150.8,8.9,149.6,11L149.6,11z",
    opacity: 0.8,
    fill: "#389bf3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.9,39.9l-15.8,30.8c-1.4,2.8-4.9,3.9-7.7,2.5c-2.8-1.4-3.9-4.9-2.5-7.7l15.7-30.9c1.4-2.8,4.9-3.9,7.7-2.5 C242.2,33.6,243.3,37.1,241.9,39.9L241.9,39.9L241.9,39.9z",
    opacity: 0.8,
    fill: "#ff9d23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.3,9l-20,37.7c-1.2,2.3-4.1,3.2-6.4,1.9c-2.3-1.2-3.2-4.1-1.9-6.4L127,4.6c1.2-2.3,4.1-3.2,6.4-1.9 C135.7,3.9,136.6,6.7,135.3,9L135.3,9z",
    fill: "#aa7dff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.8,44.4l-15.7,31c-1.5,2.8-4.9,3.9-7.8,2.5c-2.8-1.5-3.9-4.9-2.5-7.8l0,0l15.7-30.9 c1.4-2.8,4.9-3.9,7.7-2.5S222.3,41.6,220.8,44.4z",
    fill: "#389bf3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.1,27l-17,32.1c-1.1,1.9-3.6,2.5-5.5,1.4c-1.8-1.1-2.4-3.3-1.6-5.1l17.1-32c1-2,3.5-2.7,5.4-1.7 C157.4,22.7,158.2,25.1,157.1,27L157.1,27z",
    opacity: 0.5,
    fill: "#389bf3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.6,59.5l-15.7,30.9c-1.4,2.8-4.9,3.9-7.7,2.5c-2.8-1.4-3.9-4.9-2.5-7.7l15.7-30.9c1.6-2.7,5.1-3.7,7.8-2.1 C250.7,53.7,251.7,56.9,250.6,59.5L250.6,59.5z",
    opacity: 0.5,
    fill: "#aa7dff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.569,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M283.1 122.6L283.1 130.8"
  })));
}

export default SvgMagnet;